export default "__VITE_PUBLIC_ASSET__0cafdd53__"